// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bfbc23f6","667":"e9e154d3","977":"d5ca3864"}[chunkId] + ".chunk.js";
};